import { NgModule } from '@angular/core';
import { IconComponent } from './icon.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [IconComponent],
  imports: [CommonModule, HttpClientModule],
  exports: [IconComponent],
})
export class IconModule {}
